import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Carrentalmumbai() {



  const cardData = {
    keyword: " Car Rental Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and affordable car rental services in Mumbai, providing safe, comfortable, and flexible travel solutions for local rides, airport transfers, corporate travel, weddings, and outstation journeys. Whether you need a car for a few hours, a full day, or long-distance travel, our professional drivers and well-maintained fleet ensure a smooth and stress-free experience. We focus on punctual service, transparent pricing, clean vehicles, and easy booking with no hidden charges. Our fleet includes sedans, SUVs, premium cars, and Tempo Travellers suitable for all types of travelers. With 24/7 availability and quick customer support, Royal Route Cab is your trusted choice for car rental in Mumbai.",

"topPlaces": [
  {
    "title": "Car Rental Mumbai",
    "description": "Car rental services in Mumbai offer a flexible and convenient way to travel across the city for business, leisure, and personal needs. Customers can choose from a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars."
  },
  {
    "title": "Self Drive Car Rental Mumbai",
    "description": "Self drive car rental in Mumbai is ideal for customers who prefer privacy and independence while traveling. It allows users to rent a car and drive on their own for local trips and outstation journeys."
  },
  {
    "title": "Chauffeur Driven Car Rental Mumbai",
    "description": "Chauffeur-driven car rental services in Mumbai provide professional drivers for a stress-free travel experience. It is suitable for business meetings, airport transfers, and city travel."
  },
  {
    "title": "Luxury Car Rental Mumbai",
    "description": "Luxury car rental in Mumbai offers premium vehicles with high-end interiors and advanced features. It is commonly used for weddings, events, corporate travel, and special occasions."
  },
  {
    "title": "Airport Car Rental Mumbai",
    "description": "Airport car rental services in Mumbai provide convenient pickup and drop facilities for domestic and international travelers, ensuring timely and comfortable transfers."
  },
  {
    "title": "Monthly Car Rental Mumbai",
    "description": "Monthly car rental services in Mumbai are perfect for long-term users such as corporate employees and residents who need a vehicle without ownership responsibilities."
  },
  {
    "title": "Corporate Car Rental Mumbai",
    "description": "Corporate car rental in Mumbai is designed for business professionals and companies needing reliable transportation for meetings, events, and employee travel."
  },
  {
    "title": "SUV Car Rental Mumbai",
    "description": "SUV car rental services in Mumbai are ideal for group travel, family trips, and outstation journeys, offering spacious interiors and enhanced comfort."
  },
  {
    "title": "Affordable Car Rental Mumbai",
    "description": "Affordable car rental services in Mumbai provide budget-friendly transportation options without compromising on comfort, safety, and reliability."
  },
  {
    "title": "One Way Car Rental Mumbai",
    "description": "One-way car rental services in Mumbai are suitable for point-to-point travel, allowing customers to book a car for single-direction journeys at competitive prices."
  }
],






services: [
  {
    name: "Car Rental Mumbai",
    description: "Car rental Mumbai offers flexible and convenient travel solutions for local, airport, and outstation journeys. Customers can choose from a wide range of vehicles including sedans, SUVs, and premium cars. Well-maintained vehicles and professional drivers ensure safety and comfort. It guarantees a smooth and hassle-free travel experience."
  },
  {
    name: "Car Hire Mumbai",
    description: "Car hire Mumbai provides easy access to vehicles for short-term and long-term travel needs. This service is ideal for business trips, family outings, and personal travel. Flexible rental options and quick booking enhance convenience. It ensures reliable transportation."
  },
  {
    name: "Self Drive Car Rental Mumbai",
    description: "Self drive car rental Mumbai allows customers to rent vehicles and drive themselves for complete flexibility. This service is ideal for travelers who prefer privacy and independence. Well-maintained cars and simple booking process enhance convenience. It ensures a personalized travel experience."
  },
  {
    name: "Chauffeur Driven Car Rental Mumbai",
    description: "Chauffeur driven car rental Mumbai offers professional driver services for stress-free travel. This service is ideal for business meetings, events, and airport transfers. Experienced drivers ensure safety and comfort. It guarantees a premium travel experience."
  },
  {
    name: "Car Rental Booking Mumbai",
    description: "Car rental booking Mumbai allows customers to reserve vehicles easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Cheap Car Rental Mumbai",
    description: "Cheap car rental Mumbai offers budget-friendly vehicle options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures affordable travel."
  },
  {
    name: "Luxury Car Rental Mumbai",
    description: "Luxury car rental Mumbai provides premium vehicles for high-end travel and special occasions. This service includes luxury sedans and SUVs with professional chauffeurs. Comfortable interiors and stylish rides enhance the experience. It ensures a luxurious journey."
  },
  {
    name: "Daily Car Rental Mumbai",
    description: "Daily car rental Mumbai offers vehicles for full-day usage with flexible packages. This service is ideal for business trips, sightseeing, and personal travel. Multiple vehicle options are available. It ensures convenience and comfort."
  },
  {
    name: "Hourly Car Rental Mumbai",
    description: "Hourly car rental Mumbai provides short-term vehicle rental options for city travel. This service is perfect for meetings, errands, and quick trips. Flexible pricing based on hours enhances convenience. It ensures efficient and cost-effective travel."
  },
  {
    name: "Airport Car Rental Mumbai",
    description: "Airport car rental Mumbai offers convenient pickup and drop services to all airport terminals. This service ensures timely transfers for flights. Professional drivers and clean vehicles enhance comfort. It guarantees a stress-free airport experience."
  },
  {
    name: "Outstation Car Rental Mumbai",
    description: "Outstation car rental Mumbai provides reliable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway travel. It ensures a safe and comfortable journey."
  },
  {
    name: "SUV Rental Mumbai",
    description: "SUV rental Mumbai offers spacious and comfortable vehicles for family and group travel. SUVs provide extra space and better performance for long journeys. Suitable for city and outstation travel. It ensures a comfortable experience."
  },
  {
    name: "Sedan Rental Mumbai",
    description: "Sedan rental Mumbai is ideal for individuals and small families seeking affordable and comfortable travel. Sedans offer smooth rides and good mileage. Suitable for local and airport travel. It ensures a pleasant journey."
  },
  {
    name: "Innova Rental Mumbai",
    description: "Innova rental Mumbai provides premium MPV vehicles ideal for group travel and corporate trips. Spacious seating and comfort make it suitable for long journeys. Professional drivers ensure safety. It offers a premium travel experience."
  },
  {
    name: "Ertiga Rental Mumbai",
    description: "Ertiga rental Mumbai is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. Ideal for local and outstation travel. It ensures a smooth journey."
  },
  {
    name: "Best Car Rental Service Mumbai",
    description: "Best car rental service Mumbai ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and reliability. Multiple vehicle options are available. It guarantees a premium and hassle-free travel experience."
  }
],

tableData: [
  ["Car Rental Mumbai", "Car Hire Mumbai"],
  ["Self Drive Car Rental Mumbai", "Chauffeur Driven Car Rental Mumbai"],
  ["Car Rental Booking Mumbai", "Cheap Car Rental Mumbai"],
  ["Luxury Car Rental Mumbai", "Daily Car Rental Mumbai"],
  ["Hourly Car Rental Mumbai", "Airport Car Rental Mumbai"],
  ["Outstation Car Rental Mumbai", "SUV Rental Mumbai"],
  ["Sedan Rental Mumbai", "Innova Rental Mumbai"],
  ["Ertiga Rental Mumbai", "Best Car Rental Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Car Rental Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable car rental services in Mumbai for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Choose from hourly, daily, and long-term car rental packages based on your travel needs."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in handling Mumbai city and highway routes."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing with no hidden costs, ensuring complete transparency."
  },
  {
    WhyChooseheading: "24/7 Car Rental Availability",
    WhyChoosedescription: "Our car rental service in Mumbai is available 24/7, allowing you to book vehicles anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are regularly serviced, sanitized, and maintained to ensure a comfortable and safe ride."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles."
  },
  {
    WhyChooseheading: "Trusted Car Rental Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and affordable car rental services across Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide car rental service in Mumbai?", answer: "Yes, Royal Route Cabs offers car rental services in Mumbai for local and outstation travel." },
  { question: "What types of rental options are available?", answer: "We provide hourly, daily, and long-term car rental services." },
  { question: "Is car rental available 24 hours?", answer: "Yes, our Mumbai car rental service operates 24/7." },
  { question: "Which vehicles are available for rent?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and luxury vehicles." },
  { question: "Do rentals include drivers?", answer: "Yes, all our rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport car rental?", answer: "Yes, we offer Mumbai airport pickup and drop services." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "Car rental in Mumbai with Royal Route Cabs was very smooth and convenient. The vehicle was clean, well-maintained, and perfect for both local and outstation travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "Great experience with car rental service in Mumbai. The booking process was easy, and the car condition along with service quality was excellent throughout the journey.",
    rating: 5
  }
];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/car-rental-mumbai.jpg", // replace if needed
  "description": "Book car rental in Mumbai with Royal Route Cabs for safe, comfortable, and affordable travel. Available for self-drive and chauffeur-driven cars including sedan, SUV, Innova, and luxury vehicles. 24x7 airport and outstation service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting rental price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/car-rental-mumbai"
  }
};




  return (
    <div>


<Helmet>
  <title>Car Rental Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book car rental in Mumbai with Royal Route Cabs. Choose from sedan, SUV, Innova & luxury cars. Available for local, airport, and outstation travel with 24x7 service."
  />

  <meta
    name="keywords"
    content="car rental mumbai, car hire mumbai, self drive car rental mumbai, chauffeur driven car rental mumbai, car rental booking mumbai, cheap car rental mumbai, luxury car rental mumbai, daily car rental mumbai, hourly car rental mumbai, airport car rental mumbai, outstation car rental mumbai, suv rental mumbai, sedan rental mumbai, innova rental mumbai, ertiga rental mumbai, best car rental service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carrentalmumbai;